import React from 'react';
import {generatePath, useParams} from 'react-router-dom';
import CustomContainer from "../Components/CustomContainer";
import ConstructionSiteAction from "../../Actions/ConstructionSiteAction";
import CustomTranslation from "../Components/CustomTranslation";
import Loader from "../Components/Loader";
import objectImage from "../../Images/object.png";
import {Breadcrumb, Button, Image, Modal, Spinner} from "react-bootstrap";
import CustomInput from "../Components/CustomInput";
import ToolboxResult from "./Components/ToolboxResult";
import Uuid from "uuid/v1";
import ToolboxAction from '../../Actions/ToolboxAction';

class CreateToolboxScreen extends React.Component {

    //constructor
    constructor(props) {
        super(props);

        //set state
        this.state = {
            title: null,
            toolboxResults: [],
            waitModal: false
        };
    }

    componentDidMount = () => {
        this.updateElements();
    }

    //get data
    updateElements = async () => {

        //get project
        let cs = await ConstructionSiteAction.getConstructionSite(this.props.params.construction_site_id);

        //set state
        this.setState({
            data: {
                constructionSite: cs
            }
        });
    }

    //create new toolbox
    createToolbox = async () => {

        //check result and go to next page
        window.location.href = generatePath('/construction_site/:id/toolbox?title=:title', {id: this.state.data.constructionSite.id, title: this.state.title});
    }

    //clone toolbox
    cloneToolbox = async (id) => {
        //clone with call
        this.setState({waitModal: true});
        let toolbox = await ToolboxAction.getToolbox(id);
        this.setState({waitModal: false});

        let url = new URL(generatePath('/construction_site/:id/toolbox', {id: this.state.data.constructionSite.id}), window.location.origin);
        try {
            url.searchParams.append('documentId', toolbox.document.id);
        } catch (e) {}
        try {
            url.searchParams.append('title', toolbox.assignments[0].title);
        } catch (e) {}
        try {
            url.searchParams.append('actionsTaken', toolbox.assignments[0].immediateActionTaken);
        } catch (e) {}
        /*try {
            url.searchParams.append('dateRequested', toolbox.assignments[0].dateRequested);
        } catch (e) {}
        try {
            url.searchParams.append('finished', toolbox.assignments[0].dateFinished ? 1 : 0);
        } catch (e) {}
        try {
            url.searchParams.append('user', toolbox.assignments[0].targetUser.email);
        } catch (e) {}
        try {
            url.searchParams.append('concept', toolbox.assignments[0].concept ? 1 : 0);
        } catch (e) {}
        try {
            for (let [index, selectedParticpant] of Object.entries(toolbox.signatures)) {
                url.searchParams.append('selectedParticipants[]', selectedParticpant.toolboxParticipant.id);
            }
        } catch (e) {}
        try {
            url.searchParams.append('altPhotoId', toolbox.assignments[0].altPhoto.id);
        } catch (e) {}*/

        //go to next page
        window.location.href = url.toString();
    }

    //search for toolbox
    searchToolbox = async (value) => {
        //init elements
        let elements = [];

        //only if at least three characters have been entered
        if (value.length > 2) {
            //get results from call
            let result = await ToolboxAction.searchToolbox(this.state.data.constructionSite.company.id, value);
            //loop result
            result.forEach(element => {
                elements.push(
                    <ToolboxResult
                        key={Uuid()}
                        title={element.title}
                        constructionSiteName={element.name}
                        date={element.createdAt}
                        onPress={() => {
                            this.cloneToolbox(element.id);
                        }}
                    />
                )
            });
            //set in state
            this.setState({toolboxResults: elements});
        }
    }

    //check is fields are filled in
    isReady = () => {
        if (this.state.title) {
            return true;
        }
        return false;
    }

    render = () => {
        if (this.state.data) {
            return (
                <CustomContainer
                    footer={
                        <Button
                            block
                            variant={'dark'}
                            disabled={!this.isReady()}
                            onClick={() => this.createToolbox()}
                        >
                            <CustomTranslation value={'KEY.Start Toolbox'} />
                        </Button>
                    }
                >
                    <div>
                        {/* Breadcrumb */}
                        <Breadcrumb className={'vertical-margin-2'} style={{marginTop: 0}}>
                            <Breadcrumb.Item
                                href={generatePath('/')}
                            >
                                <CustomTranslation value={'KEY.Home'} />
                            </Breadcrumb.Item>
                            <Breadcrumb.Item
                                href={generatePath('/construction_site/:id', {id: this.state.data.constructionSite.id})}
                            >
                                {this.state.data.constructionSite.name}
                            </Breadcrumb.Item>
                            <Breadcrumb.Item active>
                                <CustomTranslation value={'KEY.New Instruction - Toolbox'} />
                            </Breadcrumb.Item>
                        </Breadcrumb>

                        {/* Title */}
                        <div>
                            <h1>
                                <CustomTranslation value={'KEY.New Instruction - Toolbox'} />
                            </h1>
                        </div>

                        {/* Header */}
                        <div
                            className={'bg-light rounded standard-padding vertical-padding-3'}
                            style={{position: 'relative', marginTop: '4.25rem', marginBottom: '1.25rem'}}
                        >
                            <div style={{position: 'relative', height: '3.0rem'}} />
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    flex: 1,
                                    alignItems: 'center',
                                }}
                            >
                                <Image
                                    src={objectImage}
                                    style={{position: 'absolute', objectFit: 'contain', height: '9rem', width: '9rem', top: '-4.5rem'}}
                                />
                            </div>

                            <div style={{
                                position: 'relative'
                            }}>
                                <h2><CustomTranslation value={'KEY.Project'} /> {this.state.data.constructionSite.name}</h2>
                            </div>
                        </div>

                        {/* Form */}
                        <div>
                            <div className={'vertical-margin-3'}>
                                <CustomInput
                                    label={<CustomTranslation value={'KEY.Name for toolbox'} />}
                                    iconName={'las la-comment'}
                                    onChangeText={(value) => {
                                        this.setState({title: value});
                                    }}
                                />
                            </div>
                            <div className={'vertical-margin-3'}>
                                <CustomInput
                                    label={<CustomTranslation value={'KEY.OR: Start from existing toolbox'} />}
                                    iconName={'las la-comment'}
                                    onChangeText={(value) => {
                                        this.searchToolbox(value);
                                    }}
                                />
                                {(this.state.toolboxResults.length > 0) &&
                                <div className={'bordered rounded'}>
                                    {this.state.toolboxResults}
                                </div>
                                }
                            </div>
                        </div>

                        {/* Modal */}
                        <Modal
                            show={this.state.waitModal}
                            onHide={null}
                            backdrop={'static'}
                            keyboard={false}
                        >
                            <Modal.Body>
                                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                    <div>
                                        <Spinner animation={'border'} variant={'primary'} />
                                    </div>
                                    <div>
                                        <CustomTranslation value={'KEY.Cloning toolbox please wait...'} />
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>
                    </div>
                </CustomContainer>
            );
        } else {
            return (
                <CustomContainer>
                    <Loader />
                </CustomContainer>
            );
        }
    }
}

//export
export default function (props) {
    const params = useParams();
    return <CreateToolboxScreen {...props} params={params} />;
}